const CANDU_CLIENT_TOKEN = process.env.REACT_APP_CANDU_CLIENT_TOKEN;

let loadPromise = null;
let sessionId = 0;

const Candu = {
    init(user) {
        if (!CANDU_CLIENT_TOKEN) return;
        if (!user) return;

        const userId = user.email?.address || user.id;
        const currentSession = ++sessionId;

        if (!loadPromise) {
            loadPromise = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://cdn.candu.ai/sdk/latest/candu.umd.js?token=' + CANDU_CLIENT_TOKEN;
                script.async = true;
                script.onload = () => resolve();
                script.onerror = () => {
                    script.remove();
                    loadPromise = null;
                    reject(new Error('Failed to load Candu SDK'));
                };
                document.head.appendChild(script);
            });
        }

        loadPromise
            .then(() => {
                if (currentSession !== sessionId) return;
                if (window.Candu) {
                    window.Candu.init({
                        userId,
                        clientToken: CANDU_CLIENT_TOKEN,
                        traits: {
                            email: user.email?.address,
                            name: user.displayName
                        }
                    });
                }
            })
            .catch(() => {
                /* ignore */
            });
    },

    shutDown() {
        sessionId++;
        loadPromise = null;
    }
};

export default Candu;
